import React, { useEffect, createElement } from 'react';
// Flag to prevent double initialization across hot reloads
let pixelInitialized = false;
(function initPixel() {
  if (typeof window === 'undefined') return;
  if (pixelInitialized) return;
  if ((window as any).fbq && (window as any).fbq.loaded) return;
  pixelInitialized = true;
  const n: any = (window as any).fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!(window as any)._fbq) (window as any)._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  (window as any).fbq('init', '823970021989404');
  (window as any).fbq('track', 'PageView');
})();
export function MetaPixel() {
  useEffect(() => {
    // Only add noscript fallback if not already present
    if (!document.querySelector('img[src*="facebook.com/tr?id=823970021989404"]')) {
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=823970021989404&ev=PageView&noscript=1';
      document.body.appendChild(img);
    }
  }, []);
  return null;
}